import { Component, OnDestroy, OnInit } from '@angular/core';
import { trigger, style, animate, transition, query, group } from '@angular/animations';
import { faTachometerAltAverage } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { AuthService, UserRole } from './shared/auth-service/auth.service';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { slider } from './shared/animations/slider';
import { StateService } from './shared/services/state.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        slider
    ],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'Dashboard - WebbDMS';
  today = new Date();
  homeIcon = 'fa fa-home'
  faDashboard = faTachometerAltAverage;
  loggedInUser = 'Guest';
  sidenavToggled = false;

  private _userSubscription: Subscription = new Subscription();

  activeSection: string | null = null;
  activeAdminSection: string | null = null;
  activeSystemAdminSection: string | null = null;

  toggleSection(section: string): void {
    this.activeSection = this.activeSection === section ? null : section;
    if (section !== 'admin') {
      this.activeAdminSection = null;
    }
    if (section !== 'system-admin') {
      this.activeSystemAdminSection = null;
    }
  }

  toggleAdminSection(section: string): void {
    this.activeAdminSection = this.activeAdminSection === section ? null : section;
  }

  toggleSystemAdminSection(section: string): void {
    this.activeSystemAdminSection = this.activeSystemAdminSection === section ? null : section;
  }

  constructor(public router: Router, private _authService: AuthService, private _stateService: StateService) {}

  hasRoleOrHigher(role: UserRole): boolean {
    return this._authService.hasRoleOrHigher(role);
  }

  login() {
    this._authService.login();
  }

  logout() {
    this._authService.logout();
  }

  isAuthenticated() {
    console.log("isAuthenticated", this._authService.isLoggedIn());
    this._authService.isLoggedIn();
  }

  toggleSidenav(): void {
    this.sidenavToggled = !this.sidenavToggled;
  }

  onContentClick(): void {
    if (this.sidenavToggled) {
      this.sidenavToggled = false;
    }
  }

  ngOnInit(): void {
    this._authService.isLoggedIn();
    this._stateService.load().subscribe();
    this._userSubscription = this._authService.currentLoggedInUser$.subscribe(user => {
      this.loggedInUser = user;
    });

    // Expand the sidenav section that matches the page currently displayed,
    // both on first load and on every subsequent navigation.
    this.syncActiveSection(this.router.url);
    this._userSubscription.add(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe(event => this.syncActiveSection(event.urlAfterRedirects))
    );

    console.log('Active API Environment', environment.apiUrl);
  }

  private syncActiveSection(url: string): void {
    if (url.startsWith('/sales')) {
      this.activeSection = 'sales';
    } else if (url.startsWith('/inventory')) {
      this.activeSection = 'inventory';
    } else if (url.startsWith('/admin')) {
      this.activeSection = 'admin';
      this.activeAdminSection = url.startsWith('/admin/pdf-documents') ? 'pdf-documents'
        : url.startsWith('/admin/account') ? 'account'
        : null;
    } else if (url.startsWith('/system-admin')) {
      this.activeSection = 'system-admin';
      this.activeSystemAdminSection = url.startsWith('/system-admin/pdf-documents') ? 'pdf-documents'
        : url.startsWith('/system-admin/accounts') ? 'accounts'
        : null;
    } else {
      this.activeSection = null;
    }
  }

  ngOnDestroy(): void {
    this._userSubscription.unsubscribe();
  }

  prepareRoute(outlet: RouterOutlet) {
    console.log('route data', outlet?.activatedRouteData?.['animation']);
    const animation = outlet?.activatedRouteData?.['animation'];
    console.log('Route animation:', animation);
  
    // Only allow animations for specific routes
    const allowedRoutes = ['primary', 'secondary'];
    // const currentRoute = outlet?.activatedRoute?.snapshot?.url?.[0]?.path; // Get first segment
    const currentRoute = outlet.name;
    console.log('current route', outlet.name)
    
    // const urlSegments = this.router.url.split('/');
    // const buyer = urlSegments[urlSegments.length - 1];

  
    if (!allowedRoutes.includes(currentRoute)) {
      return null; // Disable animation for all other routes
    }
  
    return animation;
 }
}
